import { render } from "./mediaShowDownload.vue?vue&type=template&id=38791208&scoped=true"
import script from "./mediaShowDownload.vue?vue&type=script&lang=js"
export * from "./mediaShowDownload.vue?vue&type=script&lang=js"

import "./mediaShowDownload.vue?vue&type=style&index=0&id=38791208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38791208"]])

export default __exports__